// // websocketService.js
// class WebSocketService {
//     constructor(url) {
//         this.url = url;
//         this.connection = null;
//         this.listeners = [];
//         this.reconnectAttempts = 0;
//         this.maxReconnectAttempts = 5;
//         this.reconnectDelay = 3000; // 3秒
//     }
//
//     connect() {
//         if (this.connection) {
//             console.warn('WebSocket is already connected.');
//             return;
//         }
//         this.connection = new WebSocket(this.url);
//
//         this.connection.onopen = () => {
//             console.log('WebSocket connected');
//             this.listeners.forEach(listener => listener(this.connection));
//             this.reconnectAttempts = 0; // 重置重连计数器
//         };
//
//         this.connection.onerror = (error) => {
//             console.error('WebSocket error:', error);
//             console.log('readyState', this.connection.readyState)
//
//
//             if (this.reconnectAttempts < this.maxReconnectAttempts) {
//                 this.reconnectAttempts++;
//                 // console.log(`尝试重新连接 (${this.reconnectAttempts}/${this.maxReconnectAttempts})...`);
//                 // setTimeout(new WebSocketService('wss://192.168.3.11:8088/ws/blockScreen'), this.reconnectDelay);
//             } else {
//                 console.error('已达到最大重连次数，停止尝试');
//             }
//         };
//
//         this.connection.onmessage = (event) => {
//             console.log('Message from server ', event.data);
//             this.listeners.forEach(listener => listener(event));
//         };
//
//         this.connection.onclose = () => {
//             console.log('WebSocket disconnected');
//             this.connection = null;
//         };
//     }
//
//     disconnect() {
//         if (this.connection) {
//             this.connection.close();
//             this.connection = null;
//         } else {
//             console.warn('WebSocket is already disconnected.');
//         }
//     }
//
//     send(data) {
//         if (this.connection && this.connection.readyState === WebSocket.OPEN) {
//             this.connection.send(JSON.stringify(data));
//         } else {
//             console.error('WebSocket is not connected.');
//         }
//     }
//
//     addListener(listener) {
//         this.listeners.push(listener);
//     }
// }
//
// export default WebSocketService;


class WebSocketService {
    constructor(url) {
        this.url = url;
        this.connection = null;
        this.messageListeners = [];
        this.statusListeners = [];
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 5;
        this.reconnectDelay = 3000; // 3秒
        this.reconnectTimer = null;
        this.manualClose = false; // 标记是否手动关闭
    }

    connect() {
        if (this.connection && this.connection.readyState === WebSocket.OPEN) {
            console.warn('WebSocket is already connected.');
            return;
        }

        this.manualClose = false;
        this.connection = new WebSocket(this.url);

        this.connection.onopen = () => {
            console.log('WebSocket connected');
            this.reconnectAttempts = 0; // 重置重连计数器
            this.notifyStatus('connected');
        };

        this.connection.onerror = (error) => {
            console.error('WebSocket error:', error);
            this.notifyStatus('error', error);

            // 只有在非手动关闭时才尝试重连
            if (!this.manualClose && this.reconnectAttempts < this.maxReconnectAttempts) {
                this.scheduleReconnect();
            }
        };

        this.connection.onmessage = (event) => {
            // console.log('Message from server:', event.data);
            this.notifyMessage(event.data);
        };

        this.connection.onclose = (event) => {
            console.log('WebSocket disconnected', event);
            this.notifyStatus('disconnected', event);

            // 只有在非手动关闭且未达最大重试次数时才尝试重连
            if (!this.manualClose && this.reconnectAttempts < this.maxReconnectAttempts) {
                this.scheduleReconnect();
            }
        };
    }

    scheduleReconnect() {
        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
        }

        this.reconnectAttempts++;
        console.log(`尝试重新连接 (${this.reconnectAttempts}/${this.maxReconnectAttempts})...`);

        this.reconnectTimer = setTimeout(() => {
            this.connect();
        }, this.reconnectDelay);
    }

    disconnect() {
        this.manualClose = true; // 标记为手动关闭
        if (this.connection) {
            this.connection.close();
            this.connection = null;
        }
        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer);
            this.reconnectTimer = null;
        }
        console.log('WebSocket manually disconnected');
    }

    send(data) {
        if (this.connection && this.connection.readyState === WebSocket.OPEN) {
            this.connection.send(JSON.stringify(data));
        } else {
            console.error('WebSocket is not connected.');
            throw new Error('WebSocket is not connected');
        }
    }

    addMessageListener(listener) {
        this.messageListeners.push(listener);
    }

    addStatusListener(listener) {
        this.statusListeners.push(listener);
    }

    removeMessageListener(listener) {
        this.messageListeners = this.messageListeners.filter(l => l !== listener);
    }

    removeStatusListener(listener) {
        this.statusListeners = this.statusListeners.filter(l => l !== listener);
    }

    notifyMessage(data) {
        try {
            const parsedData = JSON.parse(data);
            this.messageListeners.forEach(listener => listener(parsedData));
        } catch (e) {
            this.messageListeners.forEach(listener => listener(data));
        }
    }

    notifyStatus(status, data = null) {
        this.statusListeners.forEach(listener => listener({status, data}));
    }
}

export default WebSocketService;
